module.exports = __webpack_public_path__ + "img/bank.5f6aa47c.png";